import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import StickyMobileCTA from "@/components/layout/StickyMobileCTA";
import useLenis from "@/hooks/useLenis";
import { initAnalytics } from "@/lib/analytics";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}

export default function Layout() {
  useLenis();
  useEffect(() => {
    initAnalytics();
    // Persist outreach ref token so leads are attributed even after navigation
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref) {
      try { sessionStorage.setItem("gc_ref", ref); } catch (_) {}
    }
  }, []);

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <ScrollToTop />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <StickyMobileCTA />
      <div className="lg:hidden h-20" aria-hidden="true" />
    </div>
  );
}
